export default {
    //获取浏览器宽度
    documentWidth: function() {
        return document.documentElement.clientHeight
    },
    //获取浏览器高度
    documenHeight: function() {
        return document.documentElement.clientWidth
    },
}


// WEBPACK FOOTER //
// ./src/methods/window.js